<app-navbar-style-one></app-navbar-style-one>

<div class="inner-banner inner-bg8">
    <div class="container">
        <div class="inner-title">
            <h3>Services</h3>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li><i class='bx bxs-chevrons-right'></i></li>
                <li>Services</li>
            </ul>
        </div>
    </div>
</div>

<section class="service-area pt-100 pb-70">
    <div class="container">
        <div class="scetion-title text-center">
            <span>Services</span>
            <h2>Dizo Provide Good Quality Printing Services</h2>
            <p>What indication best sick be project proposal in attempt, train of the showed some a forth. That homeless, won't many of goals thoughts volumes felt.</p>
        </div>

        <div class="row pt-45">
            <div class="col-lg-4 col-md-6">
                <div class="service-card">
                    <a routerLink="/service-details"><img src="assets/img/service/service1.jpg" alt="Service Images"></a>

                    <div class="service-content">
                        <a routerLink="/service-details"><h3>Brand Identy</h3></a>
                        <p>Lorem ipsum dolor sit amet, consect is etur adipiscing elit, sed do eiusmo gd  tempor incididunt ut labore.</p>
                        <a routerLink="/service-details" class="more-btn"><i class='bx bx-plus'></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="service-card">
                    <a routerLink="/service-details"><img src="assets/img/service/service2.jpg" alt="Service Images"></a>

                    <div class="service-content">
                        <a routerLink="/service-details"><h3>Package Design</h3></a>
                        <p>Lorem ipsum dolor sit amet, consect is etur adipiscing elit, sed do eiusmo gd  tempor incididunt ut labore.</p>
                        <a routerLink="/service-details" class="more-btn"><i class='bx bx-plus'></i></a>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6">
                <div class="service-card">
                    <a routerLink="/service-details"><img src="assets/img/service/service3.jpg" alt="Service Images"></a>

                    <div class="service-content">
                        <a routerLink="/service-details"><h3>Pattern Design</h3></a>
                        <p>Lorem ipsum dolor sit amet, consect is etur adipiscing elit, sed do eiusmo gd  tempor incididunt ut labore.</p>
                        <a routerLink="/service-details" class="more-btn"><i class='bx bx-plus'></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="service-card">
                    <a routerLink="/service-details"><img src="assets/img/service/service4.jpg" alt="Service Images"></a>

                    <div class="service-content">
                        <a routerLink="/service-details"><h3>Book Cover</h3></a>
                        <p>Lorem ipsum dolor sit amet, consect is etur adipiscing elit, sed do eiusmo gd  tempor incididunt ut labore.</p>
                        <a routerLink="/service-details" class="more-btn"><i class='bx bx-plus'></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="service-card">
                    <a routerLink="/service-details"><img src="assets/img/service/service5.jpg" alt="Service Images"></a>
                    
                    <div class="service-content">
                        <a routerLink="/service-details"><h3>T-shirt Design</h3></a>
                        <p>Lorem ipsum dolor sit amet, consect is etur adipiscing elit, sed do eiusmo gd  tempor incididunt ut labore.</p>
                        <a routerLink="/service-details" class="more-btn"><i class='bx bx-plus'></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="service-card">
                    <a routerLink="/service-details"><img src="assets/img/service/service6.jpg" alt="Service Images"></a>

                    <div class="service-content">
                        <a routerLink="/service-details"><h3>Brochure Design</h3></a>
                        <p>Lorem ipsum dolor sit amet, consect is etur adipiscing elit, sed do eiusmo gd  tempor incididunt ut labore.</p>
                        <a routerLink="/service-details" class="more-btn"><i class='bx bx-plus'></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>